'use client';

import React from 'react';
import { Box } from '@mui/material';
import ReactHtmlParser from '@libs/reactHtmlParser';

type IslandMenuButtonProps = {
  t?: any;
  className?: string;
  label?: string;
  link?: string;
  small?: boolean;
};

const normalizeUrl = (url: string): string => {
  const basePath = process.env.NEXT_PUBLIC_APP_HOMEPAGE || '';
  if (!basePath || !url.startsWith(`/${basePath}`)) return url;
  return url.slice(`/${basePath}`.length) || '/';
};

export default function IslandMenuButton({
  t,
  className,
  label,
  link,
  small,
}: IslandMenuButtonProps) {
  const handleRegister = () => {
    const element = document.getElementById('fahid-island-registration');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  // ✅ SAFE label resolution (NO CRASH)
  const buttonLabel = label || t?.islandRegisterButton || 'Register';

  return (
    <Box
      component="a"
      onClick={handleRegister}
      href={link ? normalizeUrl(link) : undefined}
      className={className ?? ''}
      sx={{
        flex: '0 0 auto',
        display: 'flex',
        fontWeight: 500,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
        minWidth: {
          xs: '180px',
          sm: '180px',
          md: '200px',
          lg: '205px',
          xl: '205px',
        },
        border: 'solid 1px #fff',
        color: '#fff',
        padding: {
          xs: '0 0.75rem',
          sm: '0 0.75rem',
          md: '0 0.1rem',
          lg: '0 1rem',
          xl: '0 1.5rem',
        },
        textTransform: 'uppercase',
        letterSpacing: '0.3rem',
        minHeight: {
          xs: '36px',
          sm: '36px',
          md: '38px',
          lg: '40px',
          xl: '42px',
        },
        fontSize: {
          xs: small ? '12px' : '16px',
          sm: small ? '12px' : '16px',
          md: '18px',
          lg: '19px',
          xl: '19px',
        },
        "[dir='rtl'] &": {
          letterSpacing: 'normal',
          minWidth: {
            xs: '130px',
            sm: '130px',
            md: '136px',
            lg: '140px',
            xl: '160px',
          },
        },
      }}
    >
      {ReactHtmlParser(buttonLabel)}
    </Box>
  );
}
